/*
 *
 * LanguageProvider reducer
 *
 */
import produce from 'immer';
import { CHANGE_LOCALE } from './constants';
import { DEFAULT_LOCALE } from '../../i18n'; // eslint-disable-line
export var initialState = {
    locale: DEFAULT_LOCALE,
};
function languageProviderReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case CHANGE_LOCALE:
                state.locale = action.locale;
                break;
            default:
                break;
        }
    });
}
export default languageProviderReducer;
